import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 
import './AuthPages.css';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate   = useNavigate();
  const [form, setForm]     = useState({ email: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email.trim(), form.password);
      navigate('/dashboard');
    } catch (err) {
      const status = err.response?.status;
      if (status === 502 || status === 503 || status === 504) {
        setError('Server is waking up. Please wait 10 seconds and try again.');
      } else if (status === 500) {
        const msg = err.response?.data?.message;
        if (msg && msg !== 'Internal Server Error') {
          setError(msg);
        } else {
          setError('Server or database connection issue. Please wait a moment and try again.');
        }
      } else {
        setError(err.response?.data?.message || 'Login failed. Check your credentials.');
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-shell">
      <div className="auth-brand">
        <div className="auth-brand-inner">
          <div className="auth-logo">
            <img src="/tatsavi-lotus.png" alt="" />
            <span>Tatsavi Spaces</span>
          </div>
          <h1 className="auth-tagline">Where <em>design</em> meets <em>execution</em>, seamlessly.</h1>
          <p className="auth-desc">Manage your interior design projects, clients, payments, and team from one beautifully unified workspace.</p>
          <div className="auth-stats">
            <div><span className="stat-big">9</span><span className="stat-tiny">Modules</span></div>
            <div><span className="stat-big">360°</span><span className="stat-tiny">Project View</span></div>
            <div><span className="stat-big">3</span><span className="stat-tiny">Access Levels</span></div>
          </div>
        </div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form-box slide-up">
          <div className="auth-form-header">
            <h2 className="auth-form-title">Welcome back.</h2>
            <p className="auth-form-sub">Sign in with the account created by your admin.</p>
          </div>

          {error && <div className="alert alert-error">⚠ {error}</div>}

          <form onSubmit={submit}>
            <div className="form-group">
              <label className="form-label">Email Address</label>
              <input className="form-input" type="email" name="email" placeholder="you@tatsavispaces.com"
                value={form.email} onChange={handle} required autoComplete="email" />
            </div>
            <div className="form-group">
              <label className="form-label">Password</label>
              <div className="password-input-wrap">
                <input
                  className="form-input password-input"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="••••••••"
                  value={form.password}
                  onChange={handle}
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword((s) => !s)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  title={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? (
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20C7 20 2.73 16.89 1 12c.92-2.6 2.62-4.73 4.82-6.16" />
                      <path d="M10.58 10.58A2 2 0 0 0 12 14a2 2 0 0 0 1.42-.58" />
                      <path d="M1 1l22 22" />
                      <path d="M9.88 4.24A11.08 11.08 0 0 1 12 4c5 0 9.27 3.11 11 8a10.99 10.99 0 0 1-4.17 5.17" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading}
              style={{ marginTop: '0.5rem' }}>
              {loading ? <><span className="spinner" /> Signing in…</> : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
